<template>
  <el-card class="box-card text-left user-box" shadow="never">
    <div class="border-b pd-b-4 flex-display ai-center js-between">
      <p class="text-font-16 mg-less">{{ title }}</p>
      <span v-if="dataTable.length > 0" @click="openDialog" class="text-font-11 color-gray cursor-pointer">ดูทั้งหมด</span>
    </div>
    <div>
      <DashboardTable :dataTable="dataTable" :labels="labels"/>
    </div>
  </el-card>
</template>

<script>
import Avatar from "vue-avatar";
import DashboardTable from "./DashboardTable";

export default {
  components: {
    Avatar,
    DashboardTable
  },
  props: {
    title: {
      type: String,
      default() {
        return "";
      },
    },
    labels: {
      type: Array,
      default() {
        return [];
      },
    },
    dataTable: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    openDialog(){
      this.$emit('openDialog')
    }
    
  },
};
</script>